// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-panel[data-v-f1f5d50a] {\n  padding-right: 16px;\n}\n.template-panel .used-widget-list-expand[data-v-f1f5d50a] {\n  cursor: pointer;\n}\n.template-panel input[data-v-f1f5d50a]:disabled {\n  background: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
